<template>
  <div class="container-lg">
      <div :class="s.title">
        <p class="fs-3 fw-bold mb-4">
          <i class="fa-solid fa-home" />
          ホーム
        </p>
      </div>
      <div :class="s.buttonContainer">
        <button :class="s.btn" @click="this.$router.push('/order-list');">注文一覧画面</button>
        <button :class="s.btn" @click="this.$router.push('/checkout-list');">会計一覧画面</button>
        <button :class="s.btn" @click="this.$router.push('/');">メニュー画面</button>
      </div>
  </div>
</template>

<script>

export default {
  name: 'admin-home',
  data() {
    return {};
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  display: flex;
  justify-content: center;
}

.title {
  text-align: center;
  color: rgba(152, 121, 89, 1);
}

.form {
  text-align: center;
}

.buttonContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8vh;
}

.btn {
  display: inline-block;
  border-radius: 22px;
  border: none;
  background-color: #ffffff;
  font-weight: bold;
  color: rgba(207, 185, 146, 1);
  border: 2px solid rgba(152, 121, 89, 1);
  appearance: none;
  padding: 18vh 5vw;
  font-size: 30px;
  white-space: nowrap;
  &:hover {
    background-color: rgba(152, 121, 89, 1);
  }
}
@media (orientation: portrait) {

  .buttonContainer {
    flex-direction: column;
    gap: 4vh;
  }

  .btn {
    width: 80%;
    padding: 4vh 4vw;
    font-size: 6vw;
    white-space: normal;
  }
}
</style>
